/* global mo */

$(function(){
    var $win_select_region = $('#win_select_region');

    var region_id = $('#top_panel .contacts').data('region_id');
    var phone = get_region_phone(region_id);
    $('#top_panel .contacts .phone').html(phone);

    $('#top_panel .region_accept .ok').click(function(event){
        event.preventDefault();

        set_region_id(region_id);
        $('#top_panel .region_accept').hide();
    });

    $('a.change_region').click(function(event){
        event.preventDefault();
        var ww = $(window).width(); // ширина окна при вызове
        if(ww < 320) ww = 320;
        if(ww > 650){
            $win_select_region.dialog({width: 600});
        }else{
            $win_select_region.dialog({width: ww * 0.95});
        }
        var cityFile = 'regions_list.html';
        if(mo.pagelang === 'en'){
            cityFile = 'regions_list_en.html'
        }
        mo.preloader(true, $win_select_region);
        $.get('/tpl/common/templates/' + cityFile, function(res){
            mo.preloader(false, $win_select_region);

            $('.regions_list', $win_select_region).html(res);
        });
    });

    var timer;
    var last_value = '';
    $('[name=search_str]', $win_select_region).keyup(function(){
        var $input = $(this);
        var $results = $input.siblings('.autocomplete-results');

        if($input.val() == last_value) return;
        last_value = $(this).val();
        clearTimeout(timer);

        if(!$input.val()) return $results.empty().hide();

        timer = setTimeout(function(){
            mo.get(function(regions){
                $results.empty();
                if(!regions.length){
                    (mo.pagelang === 'en'
                        ? $results.append('<a href="" class="empty">Nothing found :(<br> Try to change your query</a>')
                        : $results.append('<a href="" class="empty">Ничего не найдено :(<br> Попробуйте переформулировать свой запрос</a>'));
                }

                $.map(regions, function(el, index){
                    (mo.pagelang === 'en'
                        ? $results.append('<a href="" data-id="' + el.id + '">' + el.name_en + '</a>')
                        : $results.append('<a href="" data-id="' + el.id + '">' + el.name + '</a>'));
                });

                $results.show();
            }, 'fias', 'search_location', {search: $input.val(), only_region: 1});
        }, 300);
    });

    $win_select_region.on('mousedown', '.autocomplete-results a, .regions_list .el', function(event){
        event.preventDefault();
        if($(this).attr('href')) return; // это ссылка на страницу

        set_region_id($(this).data('id'));
        mo.preloader();
        location.reload();
    });

    // выбор каталога
    $('#top_panel .choose_wrapper .arrow').click(function(event){
        event.preventDefault();

        var popup_id = $(this).data('popup-id');
        var $popup = $('#' + popup_id);
        $popup.show();

        var firstClick = true;
        $('body, body *').bind('mousedown.no_menuPopup', function(){
            if(!$popup.length) return; // контекстное меню было удалено

            setTimeout(function(){
                firstClick = true;
            });
            if(!firstClick) return; // клик на внешнем элементе
            firstClick = false;

            if($(this).closest('#select_catalog').length) return; // клик внутри контекстного меню
            $popup.hide();
            $('body, body *').unbind('mousedown.no_menuPopup');
        });

        $('a', $popup).click(function(event){
            event.preventDefault();
            $('a', $popup).removeClass('active');
            $(this).addClass('active');
            $('#top_panel a.catalog span.for').text($(this).text().toLowerCase());
            $('#top_panel a.catalog').attr('href', $(this).attr('href'));

            // пишем в куки
            $.cookie('catalog_url', $(this).attr('href'), {expires: 1, path: '/'}); // запоминаем url выбранного каталога
            $.cookie('catalog_name', $(this).text().toLowerCase(), {expires: 1, path: '/'}); // запоминаем название выбранного каталога
            $.cookie('catalog_id', $(this).data('catalog_id'), {expires: 1, path: '/'}); // запоминаем название выбранного каталога

            firstClick = false;
            $popup.hide();
            $('body, body *').unbind('mousedown.no_menuPopup');

            // переходим на нужную страницу
            location.href = $(this).attr('href');
        });
    });
});

// изменить регион
function set_region_id(region_id){
    $.cookie('region_id', region_id, {path: '/'});
    $.cookie('region_id_save', region_id, {path: '/'}); // куки для сохранения выбранного региона в БД
};

// получить телефон для определенного региона
function get_region_phone(region_id){
    switch(region_id){
        // Санкт-Петербург и Ленинградская область
        case 'c2deb16a-0330-4f05-821f-1d09c93331e6':
        case '6d1ebb35-70c6-4129-bd55-da3969658f5d':
            return '<a href="callto:%second_phone%">%second_phone%</a>';
    }

    return '<span href="callto:%main_phone%">%main_phone%</span>'; // Россия
}